import { ClockConfigSchema, zoneLabel, type ClockConfig } from '@hud/core';
import { registerWidget, type WidgetProps } from '../registry.js';
import { useNow } from '../hooks/useNow.js';
import './clock.css';

function Clock({ config }: WidgetProps<ClockConfig>) {
  const now = useNow(config.seconds ? 1000 : 60_000);

  const dateZone = config.dateZone ?? config.zones[0]?.tz;
  const dateText = dateZone
    ? new Intl.DateTimeFormat('en-US', {
        timeZone: dateZone,
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      }).format(now)
    : '';

  return (
    <div class="hud-clock">
      <div class="hud-clock__zones">
        {config.zones.map((zone) => (
          <div class="hud-clock__zone" key={zone.tz}>
            <div class="hud-clock__time">
              {new Intl.DateTimeFormat('en-US', {
                timeZone: zone.tz,
                hour: 'numeric',
                minute: '2-digit',
                ...(config.seconds ? { second: '2-digit' as const } : {}),
                hour12: config.hour12,
              }).format(now)}
            </div>
            <div class="hud-clock__label">{zoneLabel(zone, now)}</div>
          </div>
        ))}
      </div>
      {config.showDate && dateText ? <div class="hud-clock__date">{dateText}</div> : null}
    </div>
  );
}

registerWidget({
  type: 'clock',
  schema: ClockConfigSchema,
  component: Clock,
});
